const $ = require('jquery')
const Vue = require('vue')

Vue.directive('tab', {
    params: ['tab'],

    bind: function () {
        const $el = $(this.el)
        const $li = $el.closest('li')

        $li.addClass(`tab-${this.params.tab}`)

        $el.on('click', () => {
            const $holder = $el.closest('.tabs-holder')

            $li.siblings()
                .removeClass('active')

            $li.addClass('active')

            const $tab = $holder.find(`[data-tab=${this.params.tab}]`)

            $tab.siblings().removeClass('active')
            $tab.addClass('active')
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/tab.js